/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport(); 
  const [calendar] = useParameter<number[]>("@calendar");
  const [eCalendar] = useParameter<number[]>("@e_calendar");
  const [crop_calendar] = useParameter<number[]>("@e_crop_calendar");
  const [countries] = useParameter<number[]>("@e_countries_net_trade");
  const [commodities] = useParameter<number[]>("@commodities");
  const [business] = useParameter<number>("@business-units");
  const [commDisplay] = useParameter<number[]>("@commodities_display");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      names: { 9: title },
      parameters: {
        "@business-units": business && String(business),
        "@commodities": commodities && commodities.map(String),
        "@commodities_display": commDisplay && commDisplay.map(String),
        "@calendar": calendar && calendar.map(String),
        "@e_calendar": eCalendar && eCalendar.map(String),
        "@countries_net_trade": countries && countries.map(String),
        "@crop_calendar": crop_calendar && crop_calendar.map(String),
      }
    });
  }, [title, subtitle, exportBuilder, business, eCalendar, commDisplay, calendar, commodities, crop_calendar, countries]);
}
